import type { FC } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import type { TextFieldProps } from '@components/atoms';
import { TextField } from '@components/atoms';

export type FormTextFieldProps = TextFieldProps;

export const FormTextField: FC<FormTextFieldProps> = props => {
  const { control, formState } = useFormContext();
  const error = formState.errors[props.name];

  return (
    <Controller
      name={props.name}
      control={control}
      render={({ field }) => <TextField {...field} {...props} error={!!error} helperText={error?.message as string} />}
    />
  );
};
